export default __webpack_public_path__ + "static/media/EM0333.34I-41695_-24999_0.26cb6b8d.jpg";